module.exports = __webpack_public_path__ + "static/b-corp-logo-b12f0dc20c3dc4d94efa98b5c75b26fe.png";